import defaultsDeep from 'lodash.defaultsdeep'
import echo from '@/api/echo'

export const VERSION = 2
export const ORIGIN = process.env.VUE_APP_API_ORIGIN

export class ApiHttpError extends Error {
  constructor({ message, response, offline }) {
    super(message)
    this.message = message
    this.name = 'ApiHttpError'
    this.status = response.status
    this.url = response.url
    this.offline = offline || false

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiHttpError)
    }
  }
}

async function fetchJSON(path, method, options = {}) {
  options = defaultsDeep({}, options, {
    method,
    headers: {
      accept: 'application/json',
      'Accept-Language': 'da',
      'X-Socket-ID': echo.socketId()
    }
  })

  const url = `${ORIGIN}/api/v${VERSION}/${path}`
  let response

  try {
    response = await window.fetch(url, options)
  } catch (error) {
    throw new ApiHttpError({
      response: {
        status: null,
        url
      },
      offline: !navigator.onLine,
      message: !navigator.onLine ? 'Du har ikke forbindelse til internettet.' : error.message
    })
  }

  if (options.headers.accept === 'application/json') {
    const json = await response.json()

    if (response.ok) {
      return json
    } else {
      const errorKeys = json.errors && Object.keys(json.errors)
      const errorOptions = {
        message: '',
        response
      }

      if (!errorKeys && json.message) {
        errorOptions.message = json.message
      } else if (errorKeys && errorKeys.length > 0) {
        errorOptions.message = json.errors[errorKeys[0]][0]
      } else {
        errorOptions.message = 'No error message in payload'
      }

      throw new ApiHttpError(errorOptions)
    }
  } else {
    return response.text()
  }
}

export async function del(path, options = {}) {
  return await fetchJSON(path, 'DELETE', options)
}

export async function get(path, options = {}) {
  return await fetchJSON(path, 'GET', options)
}

export async function post(path, options = {}) {
  options.headers = {
    'content-type': 'application/json',
    ...options.headers
  }
  return await fetchJSON(path, 'POST', options)
}

export async function put(path, options = {}) {
  options.headers = {
    'content-type': 'application/json',
    ...options.headers
  }
  return await fetchJSON(path, 'PUT', options)
}
